import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon FapiaoIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const FapiaoIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 22 21">
      <path
        d="M3.48535 4.5H9.48535"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.48535 7.5H5.48535"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={6.98535} cy={14} r={3} stroke="#503291" />
      <path
        d="M16.4851 17.9286V18.9285C16.4851 19.4808 16.0374 19.9285 15.4851 19.9285H1.75646C1.20991 19.9285 0.764609 19.4897 0.756572 18.9432L0.500274 1.51495C0.492068 0.956973 0.942129 0.500244 1.50017 0.500244H12.3799C12.6313 0.500244 12.8735 0.594928 13.0582 0.765441L16.4851 3.92877V5.92874"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M12.7889 0.575777C12.9532 0.686896 15.364 2.89658 15.6622 3.12613C15.9521 3.37613 16.227 3.64411 16.4854 3.92852L12.5009 3.84242C12.0652 3.82886 11.9232 3.73337 11.9141 3.29985V0.513113C12.207 0.483258 12.5027 0.504481 12.7889 0.575777Z"
        stroke="#503291"
        strokeLinejoin="round"
      />
      <path
        d="M16.2176 11.9217L17.3319 13.9203C17.6789 14.5428 17.4681 15.3283 16.856 15.6933C16.2246 16.0698 15.4072 15.8567 15.04 15.2199L11.6797 9.3919C11.3019 8.7366 11.5351 7.89881 12.1971 7.53288C12.8502 7.17188 13.6723 7.40816 14.034 8.06085L15.0768 9.94216M16.2176 11.9217L16.6992 11.4207C16.9343 11.1762 17.2433 11.0159 17.5785 10.9646L19.5314 10.6652C20.2427 10.5562 20.8056 10.0065 20.9315 9.29805C21.0781 8.47312 20.5948 7.66619 19.7983 7.40623L19.7445 7.38866C19.081 7.17213 18.3524 7.37149 17.8916 7.89561L16.6717 9.28326C16.4465 9.53937 16.1447 9.71591 15.8111 9.78659L15.0768 9.94216M16.2176 11.9217L15.0768 9.94216"
        stroke="#503291"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default FapiaoIcon
